import { Component, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationDialogService } from './../../../confirmation-dialog/confirmation-dialog.service';
import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { HttpService } from 'src/app/services/http.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { URLUtils } from 'src/app/urlUtils';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { LeavepageComponent } from './leavepage/leavepage.component';
import { MatDialog } from '@angular/material/dialog';
import { MatterService } from '../../matter.service';

@Component({
    selector: 'app-createlegalmatter',
    templateUrl: './createlegalmatter.component.html',
    styleUrls: ['./createlegalmatter.component.scss'],
    standalone: false
})
export class CreatelegalmatterComponent implements OnInit {
  pipe = new DatePipe('en-US');
  selectedTabItem = 'matter-info';
  //selectedTabItem = 'matter-clients';
  matterInfo: any;
  highLightTeamMem: boolean = false;
  InfotoOtherTabs: any = {};
  groups: any = [];
  clients: any = [];
  teammembers: any = [];
  documents:any =[];
  clientsData: any = [];
  groupsData: any = [];
  corpData: any = [];
  teammembersData: any = [];
  docsData: any = [];
  tempClients: any;
  corpClients: any;
  corporate: any = [];
  @Output() selectedClients: any;
  @Output() selectedGroups:any;
  @Output() grouplist: any;
  product = environment.product;
  tmGrp: any = [];
  info:any;
  @Output() caseRegister:any;
  isMarketplace = false;
  private sub!: Subscription;
  clientsWereSaved = false;
  groupsWereSaved = false;
  tmsWereSaved = false;
  docsWereSaved = false;
  matterId:any;
  isEditMode = false; 
  private uploadSuccessPopupShown = false;
  isCreate :any;
  catsolo:any;
  
  constructor(private httpService: HttpService, private toast: ToastrService, private matterService: MatterService, private dialog: MatDialog,
    private router: Router, private confirmationDialogService: ConfirmationDialogService) { }

  ngOnInit() {
    this.catsolo = localStorage.getItem('category');

    const is_marketplace_string = localStorage.getItem("is_marketplace");
    if (is_marketplace_string === 'true') {
      this.isMarketplace = true; 
    }  
    
    this.router.routeReuseStrategy.shouldReuseRoute = () => false; //just refresh the compoent
    this.isEditMode = window.location.pathname.includes('/edit/');
this.isCreate = !this.isEditMode;

if (this.isEditMode) {
  this.matterId = this.router.url.split('/').pop();

  if (this.matterId) {
    this.httpService
      .sendGetRequest(URLUtils.patchLegalMatter(this.matterId))
      .subscribe((res: any) => {
        //console.log('info res',res)
        if (!res.error) {
          this.matterInfo = res.matter;
          // Save in service
          this.matterService.setLegalMatter(this.matterInfo);

          //  Save for refresh restore
          localStorage.setItem('editMatterCache', JSON.stringify(this.matterInfo));

              this.InfotoOtherTabs = {
            "Title": res.matter.title,
            "Type": res.matter.case_type,
          }
     
        } else {
          this.toast.error(res.msg);
        }
      });
  }
}

    // this.router.onSameUrlNavigation = 'reload';
    // this.router.navigate([this.router.url]);
    }
    //console.log('isMarketplace',this.isMarketplace)
  

  receiveMatterIngo(mInfo: any) {
    this.info = mInfo;
    //console.log('minfo',mInfo)
  
    if (mInfo) {
      this.InfotoOtherTabs = {
        "Title": mInfo.title,
        "Type": mInfo.case_type,
      }
      this.matterInfo = mInfo;

      if (mInfo.isEdit) {
        // Re-fetch fresh data from API after edit save
        const id = mInfo.matter_id ?? this.matterId;
        if (id) {
          this.httpService.sendGetRequest(URLUtils.patchLegalMatter(id))
            .subscribe((res: any) => {
              if (!res.error) {
                this.matterInfo = res.matter;
                this.matterService.setLegalMatter(res.matter);
                // Update cache with fresh data
                localStorage.setItem('editMatterCache', JSON.stringify(res.matter));
              }
            });
        }
        this.selectedTabItem = 'matter-clients';
        return;
      }

       // HARD GUARANTEE
      if (mInfo.matter_id) {
         this.selectedTabItem = 'matter-clients';
      } else {
      this.postData(); //create matter on info save
    }

    }

  }

  selectedGroup(groups: any) {
    this.groups = groups;
    //console.log('groups',this.groups)
    //this.selectedGroups = groups;
    this.groupsData = this.groups.map((obj: any) => obj.id);
    // console.log('groupsData',this.groupsData)
    // console.log('selectedGroups',this.selectedGroups)
    //this.selectedTabItem = 'matter-team-member';
    if(this.product == 'corporate'){
      this.selectedTabItem = 'matter-clients';
    }
    else{
      //this.selectedTabItem = 'matter-team-member'; 
      this.selectedTabItem = 'matter-documents';
    }
    // this.clients=[];
    // this.teammembers=[];
  }
  selectedClientGrp(clients: any) {
    this.groups = clients;
    //this.selectedGroups =clients;
  }

  // selectedClient(clients: any) {
  //   this.clients = clients;
  //   this.corpClients = clients;
  //   this.clientsData = this.clients.map((obj: any) => ({ "id": obj.id, "type": obj.type }));
  //   this.selectedTabItem = 'matter-groups';
  //   this.teammembers = [];
  //   this.selectedClients = this.corporate
  // }

  selectedClient(clients: any) {
    this.clients = clients;
    const corporateClient = this.clients.find((client: any) => client.type === 'corporate');
    this.corpClients = corporateClient ? corporateClient.id : '';

    this.clientsData = this.clients.map((obj: any) => ({ id: obj.id, type: obj.type }));
    // console.log('clietsDDD',this.clientsData)
    //this.selectedTabItem = 'matter-groups';
    // if(this.product == 'corporate'){
    //   this.selectedTabItem = 'matter-team-member';
    // }
    // else{
    //   this.selectedTabItem = 'matter-groups';
    // }
       
    if(this.catsolo !== 'solo')
      this.selectedTabItem = 'matter-team-member';
    else
      this.selectedTabItem = 'matter-documents';

    this.selectedClients = this.corpClients;
  }

  temporaryClients(clients: any) {
    this.tempClients = clients;
  }
  corporateClients(clients: any) {
    this.corpClients = clients;
  }
  selectedTeammemberes(teammembers: any) {
    this.highLightTeamMem = true;
    this.teammembers = teammembers;
    this.teammembersData = this.teammembers.map((obj: any) => ({ "id": obj.id }));
    this.selectedTabItem = 'matter-documents';
  }
  selectedTmGrpId(tm: any) {
    this.tmGrp = tm;
    this.teammembers = this.tmGrp
  }
  selectedDocuments(documents: any) {
    this.docsData = documents.map((obj: any) => ({
      "docid": obj.docid,
      "doctype": obj.doctype,
      "user_id": obj.user_id
    }));
    //this.postData();
  }
  convertTagsToObject(tagsArray: any[]): { [key: string]: string } {
    const tagObject: { [key: string]: string } = {};
    tagsArray.forEach((tag, index) => {
      tagObject[index] = tag.name;
    });
    return tagObject;
  }

  postData() {
    let legalMatter = {};
    // this.matterInfo.date_of_filling = this.pipe.transform(this.matterInfo.date_of_filling, 'dd-MM-yyyy');
    legalMatter = {
      "title": this.matterInfo.title,
      "case_number": this.matterInfo.case_number,
      //"matter_number": this.matterInfo.matter_number,
      "matter_id": this.matterInfo.matter_number,
      "created_date": this.matterInfo.created_date && this.pipe.transform(this.matterInfo.created_date, 'dd-MM-yyyy'),
      "date_of_filling": this.matterInfo.date_of_filling && this.pipe.transform(this.matterInfo.date_of_filling, 'dd-MM-yyyy'),
      "description": this.matterInfo.description,
      "case_type": this.matterInfo.case_type,
      "court_name": this.matterInfo.court_name,
      "judges": this.matterInfo.judges,
      "priority": this.matterInfo.priority ?? "High",
      "status": this.matterInfo.status ?? "Active",
      "affidavit_isfiled": "na",
      "affidavit_filing_date": "",
      "opponent_advocates": this.matterInfo.opponent_advocates,
      "clients": this.clientsData, 
      "tags": this.convertTagsToObject(this.matterInfo.tags),
      "group_acls": this.groupsData,
      "members": this.teammembersData,
      "documents": this.docsData,
      "temporaryClients": this.tempClients,
      "corporate": this.corpClients
    }
    // console.log("legalMatter",legalMatter)
    // console.log("mattt",this.matterInfo)
    // console.log("corporate",this.corpClients)
    //this.confirmationDialogService.confirm('Confirmation', 'Are you sure you want to create ' + this.matterInfo.title + ' ?', true, 'Yes', 'No')
  

    // SWITCH TAB to Next
    let cancel = localStorage.getItem('oncancel');
    
    if (this.isMarketplace) {
      this.selectedTabItem = 'matter-groups';
    }
    else if (cancel) {
      this.router.navigate(['/matter/legalmatter/view']);
      localStorage.removeItem('oncancel');
    }
    else {
      this.selectedTabItem = 'matter-clients';
    }

    if (!this.uploadSuccessPopupShown) {
    this.uploadSuccessPopupShown = true;
    this.httpService.sendPostRequest(URLUtils.createLegalMatter, legalMatter).subscribe((res: any) => {
      if (!res.error) {
        this.matterId = res.matter_id;

        this.InfotoOtherTabs = {
          ...this.InfotoOtherTabs,
          matterId: this.matterId
        };
        //console.log("Created Matter ID:", this.matterId);

        //         // SWITCH TAB to Next
        // if (this.product === 'corporate' || this.isMarketplace) {
        //   this.selectedTabItem = 'matter-groups';
        // } else {
        //   this.selectedTabItem = 'matter-clients';
        // }
        this.toast.success("Matter Info saved successfully");

        // if (this.docsData.length > 0) {
        //   this.add_documents_from_matter(res.matter_id)
        // }
        // let role = localStorage.getItem("role");
        // if(role !== 'TM'){
        //   this.save();
        // }
        // this.confirmationDialogService.confirm('Success', 'Congratulations! You have successfully created the matter.', true, 'View Matter List', 'Add New Matter', true, 'sm' , true, true)
        //   .then((confirmed) => {
        //     if (confirmed) {
        //       localStorage.removeItem('tempClients');
        //       this.router.navigate(['/matter/legalmatter/view']);
        //     } else {
        //       window.location.reload();
        //     }
        //   })
        // clear only your specific session items
        sessionStorage.removeItem('selectedGroups');
        sessionStorage.removeItem('groupsList');
      }
      else if (res.error)
        this.toast.error(res.msg)
    },
      (error: HttpErrorResponse) => {
        if (error.status === 401 || error.status === 403) {
          const errorMessage = error.error.msg || 'Unauthorized';
          this.toast.error(errorMessage);
          //console.log(error);
        }
      }

    )
   }
    // this.confirmationDialogService.confirm('Confirmation', 'Are you sure you want to create this matter?', true, 'Yes', 'No')
    //   .then((confirmed) => {
    //     if (confirmed) {
    //       this.httpService.sendPostRequest(URLUtils.createLegalMatter, legalMatter).subscribe((res: any) => {
    //         if (!res.error) {
    //           if (this.docsData.length > 0) {
    //             this.add_documents_from_matter(res.matter_id)
    //           }
    //           let role = localStorage.getItem("role");
    //           if(role !== 'TM'){
    //             this.save();
    //           }
    //           this.confirmationDialogService.confirm('Success', 'Congratulations! You have successfully created the matter.', true, 'View Matter List', 'Add New Matter', true, 'sm' , true, true)
    //             .then((confirmed) => {
    //               if (confirmed) {
    //                 localStorage.removeItem('tempClients');
    //                 this.router.navigate(['/matter/legalmatter/view']);
    //               } else {
    //                 window.location.reload();
    //               }
    //             })
    //           // clear only your specific session items
    //           sessionStorage.removeItem('selectedGroups');
    //           sessionStorage.removeItem('groupsList');
    //         }
    //         else if (res.error)
    //           this.toast.error(res.msg)
    //       },
    //         (error: HttpErrorResponse) => {
    //           if (error.status === 401 || error.status === 403) {
    //             const errorMessage = error.error.msg || 'Unauthorized';
    //             this.toast.error(errorMessage);
    //             console.log(error);
    //           }
    //         }

    //       )
    //     }
    //   })
    //   .catch(() => { });
  }


  save() {
    let data = { "members": this.teammembers.map((obj: any) => obj.id) };

    const tempclients = JSON.parse(localStorage.getItem("tempclients") || "[]");
    //console.log('--tempclients', tempclients)

    if (Array.isArray(tempclients) && tempclients.length > 0) {
      let completed = 0;

      tempclients.forEach((id: any) => {
        this.httpService.sendPutRequest(URLUtils.updateRelationshipMember(id), data).subscribe(
          (res: any) => {
            completed++;
            if (completed === tempclients.length) {
              // Clear only when last call is done
              localStorage.removeItem('isTemp');
              localStorage.removeItem('tempclients');
            }
          },
          (err: any) => {
            console.error(`PUT failed for ${id}`, err);
          }
        );
      });
    }
  }

  add_documents_from_matter(matter_id: any) {
    const doc: string[] = this.docsData.map((item: any) => item.docid);
    let data = {
      "matter_id": matter_id,
      documents: doc
    }
    this.httpService.sendPatchRequest(URLUtils.updateDocwithMatters, data).subscribe((res: any) => {
      //console.log(res)
    })
  }


  onClientsSaved(saved: boolean) {
    this.clientsWereSaved = saved;
    //console.log('Clients saved status:', this.clientsWereSaved);
  }

  onGroupsSaved(saved: boolean) {
    this.groupsWereSaved = saved;
    //console.log('Groups saved status:', this.groupsWereSaved);
  }
  onTmsSaved(saved: boolean) {
    this.tmsWereSaved = saved;
    //console.log('Tms saved status:', this.tmsWereSaved);
  }
  onDocsSaved(saved: boolean) {
    this.docsWereSaved = saved;
    //console.log('Docs saved status:', this.docsWereSaved);
  }

  // changeTab(sel: any) {
  //   // console.log('sel',sel)
  //   // console.log('clients', this.clients);
  //   // console.log('groups', this.groups);
  //   // console.log('tms', this.teammembers);
  //   // console.log('docs', this.documents);
  //   // console.log('c d', this.clientsData)
  //   // console.log('g d', this.groupsData)
  //   // console.log('t d', this.teammembersData)
  //   // console.log('d d', this.docsData)

  //   this.clients = this.httpService.getClients();
  //   //this.groups = this.httpService.getGroups();
  //   this.teammembers = this.httpService.getTms();
  //   this.documents = this.httpService.getDocs();
    
  //   // console.log('save ccc', this.clients)
  //   // console.log('save ggg', this.groups)
  //   // console.log('save ttt', this.groups)
  //   // console.log('save ddd', this.groups)

  //   // if user tries to go back but without save
  //   if (this.clients.length > 0 && this.clientsWereSaved === false) {
  //     //this.toast.error('Please save your clients before going back.');
  //     this.dialog.open(LeavepageComponent, {
  //       width: '350px',  // Set the width here
  //       height: '180px',
  //       hasBackdrop: true,
  //       panelClass: 'hello',
  //       disableClose: true
  //     });
  //     return;
  //   }
  //   // if (this.groups.length > 0 && this.groupsWereSaved === false) {
  //   //   //this.toast.error('Please save your clients before going back.');
  //   //   this.dialog.open(LeavepageComponent, {
  //   //     width: '350px',  // Set the width here
  //   //     height: '180px',
  //   //     hasBackdrop: true,
  //   //     panelClass: 'hello',
  //   //     disableClose: true
  //   //   });
  //   //   return;
  //   // }
  //   if (this.teammembers.length > 0 && this.tmsWereSaved === false) {
  //     //this.toast.error('Please save your clients before going back.');
  //     this.dialog.open(LeavepageComponent, {
  //       width: '350px',  // Set the width here
  //       height: '180px',
  //       hasBackdrop: true,
  //       panelClass: 'hello',
  //       disableClose: true
  //     });
  //     return;
  //   }
  //   if (this.documents.length > 0 && this.docsWereSaved === false) {
  //     //this.toast.error('Please save your clients before going back.');
  //     this.dialog.open(LeavepageComponent, {
  //       width: '350px',  // Set the width here
  //       height: '180px',
  //       hasBackdrop: true,
  //       panelClass: 'hello',
  //       disableClose: true
  //     });
  //     return;
  //   }

  //   // proceed if saved or true
  //   // this.selectedTabItem = 'matter-info';
  //   this.selectedTabItem = sel;
  // }

  changeTab(sel: any) {
    // console.log('save ccc', this.clients)
    // console.log('save ggg', this.groups)
    // console.log('save ttt', this.teammembers)

    this.clients = this.httpService.getClients();
    //this.groups = this.httpService.getGroups();
    this.teammembers = this.httpService.getTms();
    this.documents = this.httpService.getDocs();

    // proceed if saved or true
    // this.selectedTabItem = 'matter-info';
    this.selectedTabItem = sel;
  }

}
